import windStationsAPI from 'common/api/windStations';

const { useGetWindStationsInBoundingBoxQuery } = windStationsAPI;

export default useGetWindStationsInBoundingBoxQuery;
